
import React from 'react';

import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { connect } from 'react-redux';
import { updateProcessDetail } from '../../../storage/pipelineSlice';


class InteractiveProcess extends React.Component {
    value = ''
    constructor(props) {
        super(props);
        this.state = {
            
        }
    }

    componentDidMount() {
    }

    render() {
        console.log(`render Interactive process`)
        const { processLog, updateProcessDetail, requestingUpdateProcess } = this.props;
        console.log(`requestingUpdateProcess  ${requestingUpdateProcess}`);
        const source = process.env.REACT_APP_API_URL + processLog.status_detail.file;
        const currentValue = processLog.status_detail.value;
        console.log(`currentValue  ${currentValue}`);
        console.log(`currentValue != undefined  ${currentValue !== undefined}`);
        return (      
            <div className="timeline-panel">
                <img src={source} alt="Captcha"/>
                { currentValue === undefined ? <div>
                    <TextField
                        onChange={(e)=> {this.value = e.target.value}}     
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="captcha"
                        label="Digite las letras en imagen"
                        name="captcha"
                        autoFocus
                        type="text"/>
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            console.log(`processLog value ${this.value}`);
                            processLog.status_detail.value = this.value;
                            console.log(`processLog after ${JSON.stringify(processLog)}`);
                            updateProcessDetail({processLog});
                        }}
                        >
                        Enviar
                    </Button>
                </div> :
                    <p>{currentValue}</p>
                }
            </div> 
        );
    }

    componentWillUnmount() {
        
    }
}

const mapdispatchToProps = {
    updateProcessDetail: updateProcessDetail,    
};

const mapStateToProps = state => {
    return {
        requestingUpdateProcess: state.pipeline.requestingUpdateProcess,
        activeUser: state.mainReducer.activeUser,
    };
};

export default connect(mapStateToProps, mapdispatchToProps)(InteractiveProcess);